import { Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import TF from '../api/requests/tf_backend';

const Home = () => {
  const [userInfo, setUserInfo] = useState(null);
  const redirect = () => {
    window.location.href = `https://kite.zerodha.com/connect/login?api_key=${userInfo.api_key}&v=3`;
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      const response = await TF.getUserInfo();
      setUserInfo(response);
    };
    fetchUserInfo();
  }, []);
  

  return (
    <>
      <div>
        <Typography variant="h4" gutterBottom>Welcome to Home Page</Typography>
        <Typography>This is the Home Page content.</Typography>
        <button onClick={redirect}>Redirect</button>
      </div>
    </>
  );
};

export default Home;
